export const ASTRAL_WALLET_IFRAME_ID = 'astral-wallet-iframe';

export enum AstralWalletIFrameMessage {
  REDIRECT_TO_CONFIRM_PAGE = 'redirect_to_confirm_page',
  CHANGE_PAYMENT_METHOD = 'change_payment_method',
  CANCEL_ORDER = 'cancel_order',
  TRY_AGAIN_PAYMENT = 'try_again_payment',
  LOCK_ASTRAL_WALLET = 'lock_astral_wallet',
}

export enum AstralWalletParentMessage {
  TOGGLE_ASTRAL_WALLET_LOADER = 'toggle_astral_wallet_loader',
}
